import { Auth, Storage } from 'aws-amplify';
import API from '../api-graphql';
import APIUruk from '../api-rest-uruk';
import { store } from '../store';
import { CONSTANTS } from '../constants/constants';
import defaultLogo from '../assets/urukcolor.png';

export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SET_FILTER = 'SET_FILTER';
export const GET_MORE_BUNDLES = 'GET_MORE_BUNDLES';
export const GET_MORE_DOCUMENTS = 'GET_MORE_DOCUMENTS';
export const GET_MORE_TEMPLATES = 'GET_MORE_TEMPLATES';
export const GET_MORE_IDENTITIES = 'GET_MORE_IDENTITIES';
export const GET_ALL_BUNDLES = 'GET_ALL_BUNDLES';
export const GET_ALL_DOCUMENTS = 'GET_ALL_DOCUMENTS';
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';
export const GET_ALL_IDENTITIES = 'GET_ALL_IDENTITIES';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const CLEAN_STATE = 'CLEAN_STATE';
export const SET_SIGNER_USER = 'SET_SIGNER_USER';

export const saveConfig = (payload) => ({ type: SAVE_CONFIG, payload });
export const setFilter = (payload) => ({ type: SET_FILTER, payload });
export const cleanState = (payload) => ({ type: CLEAN_STATE, payload });
export const setMoreTemplates = (payload) => ({ type: GET_MORE_TEMPLATES, payload });
export const setTemplates = (payload) => ({ type: GET_ALL_TEMPLATES, payload });
export const setMoreDocuments = (payload) => ({ type: GET_MORE_DOCUMENTS, payload });
export const setDocuments = (payload) => ({ type: GET_ALL_DOCUMENTS, payload });
export const setMoreBundles = (payload) => ({ type: GET_MORE_BUNDLES, payload });
export const setBundles = (payload) => ({ type: GET_ALL_BUNDLES, payload });
export const setMoreIdentities = (payload) => ({ type: GET_MORE_IDENTITIES, payload });
export const setIdentities = (payload) => ({ type: GET_ALL_IDENTITIES, payload });
export const setSignerUser = (payload) => ({ type: SET_SIGNER_USER, payload });

const selectCurrentUrl = (url) => {
  if (url === '/document/finished') return [CONSTANTS.FLOW.STATUS.SIGNED, CONSTANTS.FLOW.STATUS.CANCELLED];
  else return [CONSTANTS.FLOW.STATUS.INIT, CONSTANTS.FLOW.STATUS.SEND_TO_SIGN, CONSTANTS.FLOW.STATUS.REJECTED, CONSTANTS.FLOW.STATUS.ERROR];
};

const orderTabs = (tabs) => {
  return tabs.sort(({ order: aOrder }, { order: bOrder }) => aOrder - bOrder);
};
export const saveSignerUser = (user) => {
  return async (dispatch) => {
    dispatch(setSignerUser(user));
    return user;
  };
};

export const getConfig = (user, newGroup, newSubgroup, newRole) => {
  return async dispatch => {
    try {
      if (newGroup && newSubgroup) {
        await Auth.updateUserAttributes(user, { 'custom:group': newGroup, 'custom:subgroup': newSubgroup, 'custom:role': newRole });
      }

      let group = user.signInUserSession.idToken.payload.group;
      let subgroup = user.signInUserSession.idToken.payload.subgroup;
      let role = user.signInUserSession.idToken.payload.role;
      const configId = user.signInUserSession.idToken.payload.configId;
      const roleId = user.signInUserSession.idToken.payload.roleId;

      const groups = JSON.parse(user.signInUserSession.idToken.payload.groups);
      const { context } = groups.find(({ context }) => context.name === subgroup);

      let config = await APIUruk.getApplication(configId);

      const { tabs } = config.roles.filter((role) => role.id === Number(roleId))[0] || config.roles[0];
      const orderedTabs = orderTabs(tabs);
      const visibleTabs = orderedTabs.map(({ tab }) => tab);

      if (config.theme) {
        const { theme: { logo: configLogo } } = config;
        if (configLogo) {
          config.theme.logo = configLogo && configLogo.startsWith('http') ? configLogo : await Storage.get(configLogo.replace('public/', ''));
        } else {
          config.theme.logo = defaultLogo;
        }
      }

      if (config.activeContext.theme && config.activeContext.theme.logo) {
        const { theme: { logo: contextLogo } } = config.activeContext;
        if (contextLogo) {
          config.theme.logo = contextLogo && contextLogo.startsWith('http') ? contextLogo : await Storage.get(contextLogo.replace('public/', ''));
        }
      }

      config = {
        ...config,
        visibleTabs,
        group,
        subgroup,
        role,
        groups,
        user,
        context
      };

      dispatch(saveConfig(config));
      return config;
    } catch (err) {
      console.error(err);
      await Auth.signOut();
    }
  };
};

export const getDocuments = () => {
  let pathArray = window.location.href.split('/');
  let filterStatus;
  let filter;
  let filters;
  let docType;
  let statusList;
  let owner;

  return async (dispatch, getState) => {
    switch (pathArray[pathArray.length - 1]) {
      case 'finished':
        docType = 'document';
        statusList = [CONSTANTS.FLOW.STATUS.SIGNED, CONSTANTS.FLOW.STATUS.CANCELLED, CONSTANTS.FLOW.STATUS.EXPIRED];
        filters = getState().filter.finished;
        filterStatus = {
          and: [
            { type: { eq: docType } },
            { or: statusList.map(element => ({ status: { contains: element } })) }
          ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
        };

        owner = getState().filter.owner;
        if (owner) filterStatus.and.push({ owner: { eq: owner } });

        filter = filterStatus;
        break;
      case 'document':
        docType = 'document';
        statusList = [CONSTANTS.FLOW.STATUS.INIT, CONSTANTS.FLOW.STATUS.SEND_TO_SIGN, CONSTANTS.FLOW.STATUS.REJECTED, CONSTANTS.FLOW.STATUS.ERROR];
        filters = getState().filter.pending;
        filterStatus = {
          and: [
            { type: { eq: docType } },
            { or: statusList.map(element => ({ status: { contains: element } })) }
          ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
        };

        owner = getState().filter.owner;
        if (owner) filterStatus.and.push({ owner: { eq: owner } });

        filter = filterStatus;
        break;
      case 'file':
        docType = 'file';
        filters = getState().filter.files;
        filterStatus = {
          and: [
            { type: { eq: docType } },
            { not: { status: { contains: 'deleted' } } }
          ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
        };
        filter = filterStatus;
        break;
      case 'notification':
        docType = [
          'certifiedNotification', // legacy type
          'notification'
        ];
        filters = getState().filter.files;
        filterStatus = {
          and: [
            {
              or: docType.map(type => ({ type: { eq: type } }))
            },
            { not: { status: { contains: 'deleted' } } }
          ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
        };
        filter = filterStatus;
        break;
      default:
        break;
    }
    const result = await API.listDocuments(filter, getState().config.subgroup, null);
    dispatch(setDocuments(result.data.listDocuments));
    return result;
  };
};

export const getMoreDocuments = (currentPage, search, docType) => {
  const statusList = selectCurrentUrl(currentPage);
  let filterStatus;
  const or = statusList.map(element => ({ status: { contains: element } }));
  if (currentPage === '/document/finished') {
    filterStatus = { or };
  } else {
    filterStatus = {
      and: [
        { type: { eq: docType } },
        { or }
      ]
    };
  }
  const filter = search ? Object.assign(filterStatus, search) : filterStatus;
  const state = store.getState();
  return async dispatch => {
    if (state.documents.nextToken) {
      const result = await API.listDocuments(filter, state.config.subgroup, state.documents.nextToken);
      dispatch(setMoreDocuments(result.data.listDocuments));
      return result;
    }
  };
};

export const getTemplates = () => {
  return async (dispatch, getState) => {
    const { filter: { templates: filters }, config: { subgroup } } = getState();
    const arrFilter = () => filters && filters.length ? filters.map(filter => (
      { searchField: { contains: filter }
      })) : [];
    const objFilter = { and: arrFilter() };
    const filter = objFilter.and.length ? objFilter : null;
    const result = await API.listTemplates(filter, subgroup);
    dispatch(setTemplates(result.data.listTemplates));
    return result;
  };
};

export const getBundles = (searchByDocument) => {
  return async (dispatch, getState) => {
    const filters = getState().filter.bundle || [];
    const filterStatus = {
      and: [
        { status: { notContains: 'deleted' } }
      ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
    };
    const filter = filters.map(filter => filter);
    const filterStatusForDocument = {
      and: [
        { status: { notContains: 'deleted' } }
      ],
      filterDoc: { searchField: { contains: filter[0] || '' } }
    };
    const result = await API.listBundles(searchByDocument ? filterStatusForDocument : filterStatus, getState().config.subgroup, null, searchByDocument);
    if (searchByDocument) {
      dispatch(setBundles(result.data.listBundles));
      if (filterStatusForDocument.filterDoc.searchField.contains === '') {
        dispatch(setBundles([]));
      } else {
        dispatch(setBundles(result.data.listBundles));
      }
    } else if (!searchByDocument) {
      dispatch(setBundles(result.data.listBundles));
    }
    return result;
  };
};

export const getMoreBundles = (searchByDocument) => {
  return async (dispatch, getState) => {
    const state = store.getState();
    if (state.bundles.nextToken) {
      const filters = getState().filter.bundle || [];
      const filterStatus = {
        and: [
          { status: { notContains: 'deleted' } }
        ].concat((filters && filters.length) ? filters.map(filter => ({ searchField: { contains: filter } })) : [])
      };
      const filter = filters.map(filter => filter);
      const filterStatusForDocument = {
        and: [
          { status: { notContains: 'deleted' } }
        ],
        filterDoc: { searchField: { contains: filter[0] || '' } }
      };
      const result = await API.listBundles(searchByDocument ? filterStatusForDocument : filterStatus, getState().config.subgroup, state.bundles.nextToken, searchByDocument);
      if (searchByDocument) {
        dispatch(setMoreBundles(result.data.listBundles));
        if (filterStatusForDocument.filterDoc.searchField.contains === '') {
          dispatch(setMoreBundles([]));
        } else {
          dispatch(setMoreBundles(result.data.listBundles));
        }
      } else if (!searchByDocument) {
        dispatch(setMoreBundles(result.data.listBundles));
      }
      return result;
    }
  };
};

export const getIdentities = () => {
  return async (dispatch, getState) => {
    const { filter: { identity: filters }, config: { subgroup } } = getState();
    const arrFilter = () => filters && filters.length ? filters.map(filter => (
      { searchField: { contains: filter }
      })) : [];
    const objFilter = { and: arrFilter() };
    const filter = objFilter.and.length ? objFilter : null;
    const result = await API.listUsers(filter, subgroup, null);
    dispatch(setIdentities(result.data.listUsers));
    return result;
  };
};

export const getMoreIdentities = (search) => {
  const state = store.getState();
  return async dispatch => {
    if (state.documents.nextToken) {
      const result = await API.listDocuments(search, state.config.subgroup, state.identity.nextToken);
      dispatch(setMoreDocuments(result.data.listDocuments));
      return result;
    }
  };
};
